import React from 'react';
import {
  $BannerContent,
  $BannerTitle,
  $BannerFeatures,
  $ButtonContainer,
  $TryNowButton,
  $ReadDocumentationButton,
  $DemoContainer,
} from './AvsPromotionBannerContent.styled';
import Icon from '../Icon';

interface Props {
  onTryNow: () => void;
  onReadDocumentation?: () => void;
}

function AvsPromotionBannerContent({ onTryNow, onReadDocumentation }: Props) {
  return (
    <>
      <$DemoContainer>
        <img
          src="/images/accountVerification/ae-bank-card.svg"
          alt="Account verification icon"
        />
      </$DemoContainer>
      <$BannerContent>
        <span className="new-service">NEW SERVICE</span>
        <$BannerTitle>Easily verify account ownership</$BannerTitle>
        <$BannerFeatures>
          <li>Minimise risk of fraud & AML</li>
          <li>Reduce misrouted funds</li>
          <li>Near zero chance of bounce-backs</li>
        </$BannerFeatures>
        <$ButtonContainer>
          <$TryNowButton onClick={onTryNow}>
            Try now <Icon name="ArrowForward" size={16} />
          </$TryNowButton>
          {onReadDocumentation && (
            <$ReadDocumentationButton onClick={onReadDocumentation}>
              Learn more
            </$ReadDocumentationButton>
          )}
        </$ButtonContainer>
      </$BannerContent>
    </>
  );
}

export default AvsPromotionBannerContent;
